import { render, staticRenderFns } from "./MonitObserveTableMenu.vue?vue&type=template&id=d2bf8080&"
import script from "./MonitObserveTableMenu.vue?vue&type=script&lang=js&"
export * from "./MonitObserveTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports